@mixin cardText() {
  font-family: "Inter";
  font-style: normal;
  color: #16182b;
}

.parent {
  cursor: pointer;
  width: 100%;
  max-width: 565px;
  height: 54px;
  margin: auto;
  margin-bottom: 16px;
  margin-top: 2px;
  display: flex;
  position: relative;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;

  & .itemContent {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
    justify-content: center;

    & .label {
      @include cardText();
      font-size: 14px;
    }

    & .description {
      @include cardText();
      margin-top: 4px;
      font-weight: bold;
      font-size: 10px;
      opacity: 0.5;
    }
  }

  &.selectedBorder {
    outline: 2px solid #4d5ef2;
  }

  & input[type="radio"]:checked ~ .radioSpan {
    background-color: #4d5ef2;
    visibility: visible;
  }

  & .radioButton {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-user-select: none;
    appearance: none;
    user-select: none;
    margin: 15px 24px 15px 15px;
    width: 24px;
    height: 24px;
    display: flex;
    box-sizing: border-box;
    border-radius: 5000px;
    border: 2px solid #16182b;
    pointer-events: none;
  }

  & .radioButton:checked {
    border: 2px solid #4d5ef2;
  }

  & .radioSpan {
    margin: 21px 0px 21px 21px;
    width: 12px;
    height: 12px;
    position: absolute;
    display: flex;
    border-radius: 5000px;
    background-color: #16182b;
    visibility: hidden;
  }
}
